import React, { useState, useEffect, useCallback, useRef } from 'react';
import { apiGet, apiDelete, apiUpload, API_ORIGIN } from '../services/api';

const CATS = [
  { v: 'ppto',     l: 'Presupuesto' },
  { v: 'factura',  l: 'Factura' },
  { v: 'contrato', l: 'Contrato' },
  { v: 'otro',     l: 'Otro' },
];
const CAT_LABEL = Object.fromEntries(CATS.map(c => [c.v, c.l]));

const fmtSize = b => b >= 1048576 ? (b / 1048576).toFixed(1) + ' MB' : b >= 1024 ? Math.round(b / 1024) + ' KB' : (b || 0) + ' B';
const fmtDT = s => { if (!s) return ''; const d = new Date(String(s).replace(' ', 'T')); return isNaN(d) ? '' : d.toLocaleString('es-ES', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }); };
const iconFor = m => (m || '').startsWith('image/') ? '🖼️' : (m || '').includes('pdf') ? '📄' : (m || '').includes('sheet') || (m || '').includes('excel') ? '📊' : (m || '').includes('word') ? '📝' : '📎';

const btn = (bg, c) => ({ background: bg, color: c, border: c === '#fff' ? 'none' : `1px solid ${c}`, borderRadius: 8, padding: '8px 13px', fontWeight: 700, fontSize: 13, cursor: 'pointer' });

export default function DocumentsBox({ entityType, entityId, token }) {
  const [docs, setDocs] = useState(null);
  const [cat, setCat] = useState('ppto');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const fileRef = useRef(null);

  const load = useCallback(() => {
    apiGet(`/documents?entity_type=${entityType}&entity_id=${entityId}`, token)
      .then(d => setDocs(Array.isArray(d) ? d : [])).catch(() => setDocs([]));
  }, [entityType, entityId, token]);
  useEffect(() => { load(); }, [load]);

  async function onFile(e) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setBusy(true); setErr('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('entity_type', entityType);
      fd.append('entity_id', entityId);
      fd.append('category', cat);
      await apiUpload('/documents', fd, token);
      load();
    } catch (ex) { setErr(ex.message); }
    setBusy(false);
    if (fileRef.current) fileRef.current.value = '';
  }

  async function remove(id) {
    if (!window.confirm('¿Eliminar este documento?')) return;
    try { await apiDelete(`/documents/${id}`, token); load(); }
    catch (ex) { alert(ex.message); }
  }

  return (
    <div style={{ padding: 4 }}>
      {/* Subida */}
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 14 }}>
        <select value={cat} onChange={e => setCat(e.target.value)} disabled={busy}
          style={{ padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13 }}>
          {CATS.map(c => <option key={c.v} value={c.v}>{c.l}</option>)}
        </select>
        <input ref={fileRef} type="file" onChange={onFile} disabled={busy} style={{ display: 'none' }}
          accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,image/*" />
        <button style={btn('#E84300', '#fff')} onClick={() => fileRef.current && fileRef.current.click()} disabled={busy}>
          {busy ? 'Subiendo…' : '⬆ Subir documento'}
        </button>
      </div>
      {err && <p style={{ color: '#dc2626', fontSize: 13, margin: '0 0 10px' }}>{err}</p>}

      {/* Listado */}
      {docs === null ? (
        <p style={{ color: '#94a3b8', fontSize: 13 }}>Cargando…</p>
      ) : docs.length === 0 ? (
        <p style={{ color: '#94a3b8', fontSize: 13 }}>Aún no hay documentos. Sube presupuestos externos, facturas, contratos, etc.</p>
      ) : docs.map(d => (
        <div key={d.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderTop: '1px solid #f1f5f9' }}>
          <span style={{ fontSize: 22 }}>{iconFor(d.mime)}</span>
          <div style={{ minWidth: 0, flex: 1 }}>
            <div style={{ fontWeight: 600, fontSize: 14, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{d.filename}</div>
            <div style={{ fontSize: 12, color: '#94a3b8' }}>
              <span style={{ fontWeight: 700, color: '#4f46e5' }}>{CAT_LABEL[d.category] || 'Otro'}</span>
              {' · '}{fmtSize(d.size)}{' · '}{fmtDT(d.created_at)}{d.uploaded_by_name ? ` · ${d.uploaded_by_name}` : ''}
            </div>
          </div>
          <a href={API_ORIGIN + d.url} target="_blank" rel="noopener noreferrer" style={{ ...btn('#fff', '#0f766e'), textDecoration: 'none' }}>Ver</a>
          <a href={API_ORIGIN + d.url + '?download=1'} style={{ ...btn('#fff', '#475569'), textDecoration: 'none' }}>⬇</a>
          <button style={btn('#fff', '#dc2626')} onClick={() => remove(d.id)} title="Eliminar">✕</button>
        </div>
      ))}
    </div>
  );
}
